import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { MwService } from '~app/shared/services/mw/mw.service';
import { IGetCountryListResponse } from '../services/mw/interfaces/GetCountryList.interface';

@Injectable()
export class CountryListResolver {
  constructor(private readonly mw: MwService) {}

  public resolve(): Observable<IGetCountryListResponse> {
    return this.mw.getCountryList();
  }
}
